import Grid from '@mui/material/Grid';
import AgyleTextField from '../../../../../components/ui/fields/agyleTextField';
import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';
import {appointmentBooksState, setAppointmentBooksState} from '../../../../../store/reducers/appointments';
import AttendanceList from './attendanceList';
import {useState} from 'react';

const AppointmentLinkedAttendance = ({patient}) => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const [activities, setActivities] = useState(null);

    // Selector
    const bookState = useSelector(appointmentBooksState);

    const handleReason = (event) => {
        const {value} = event.target;
        dispatch(setAppointmentBooksState({
            reason: value,
        }));
    };

    return (
        <>
            <AttendanceList patient={patient} activities={activities} setActivities={setActivities}/>

            <Grid item xs={12} sx={{pl: 1}}>
                <AgyleTextField
                    fullWidth
                    value={bookState.reason}
                    noBorder={false}
                    placeholder={t('Provide reason for appointment')}
                    onChange={handleReason}
                    required
                    error={!bookState.reason}
                />
            </Grid>
        </>
    );
};

export default AppointmentLinkedAttendance;